import './Product.scss'

const Product = ({id,pid, brand, model, img, type, qty, price_name1,price1,price_name2,price2,handleClickProduct,size, row_order,condition}) =>{
    console.log(id,pid,qty)
    if(parseInt(qty) > 0 || condition === 'so' || condition === 'new'){
                return (
                    <div className="product-item">
                        <div className="product-item-header">
                            <h2>{brand}</h2>
                            {
                                condition === 'so' ? (<div className="product-item-qty"><p className="label bold">Special</p><p className="label bold">order</p></div>) 
                                : (<div className="product-item-qty"><p className="label">Qty</p><p className="title">{qty}</p></div>)
                            }
                        </div>
                        <img src={img} alt={`${brand}-${model}-${pid}`} />
                        <ul className="product-item-list">
                            <li>
                                <p className="label inline-block">Product Id</p>
                                <h3 className="title inline-block pl20">{pid}</h3>
                                <p className="label inline-block pl20">Rid</p>
                                <h3 className="title inline-block pl20">{row_order}</h3>
                            </li>
                            <li>
                                <p className="label">Model</p>
                                <h3 className="title">{model}</h3>
                            </li>
                            <li>
                                <p className="label">Condition</p>
                                <h3 className="title">{condition === 'so' ? 'special order' : condition}</h3>
                            </li>
                            { price1 || price2 ? (
                                <li>
                                    <p className="label">Pricing</p>
                                    <div className="product-item-price">
                                        {
                                            price1 ? (
                                                <div>
                                                    <div dangerouslySetInnerHTML={{__html:price_name1}}></div>
                                                    {price1 ? (<p className={`sub-title ${price_name1 ? '' : 'bold'}`}>${price1}</p> ): null }
                                                </div>
                                            ) : null
                                        }
                                        { price2?(
                                            <div>
                                                <div dangerouslySetInnerHTML={{__html:price_name2}}></div>
                                                {price2 ? (<p className={`sub-title ${price_name2 ? '' : 'bold'}`}>${price2}</p>) : null}
                                            </div>
                                        ):null}
                                    </div>
                                </li>
                            ) : (<li><div className='bold'>Call for pricing</div></li>)}
                        </ul>
                        {
                            type && (<ul className="product-item-type">
                                {type.split(',').map(item=>(<li>{item}</li>))}
                            </ul>)
                        }
                        {size && (
                            <ul className="product-item-list">
                                <li>
                                    <p className="label inline-block">Size</p>
                                    <h3 className="title inline-block pl20">{size}</h3>
                                </li>
                            </ul>
                        )}

                        <div className="product-item-list footer">
                            <div className="product-item-container" >
                                <button onClick={()=>handleClickProduct(id)}>View detail</button>
                            </div>
                        </div>
                    </div>
                )
            }
            return null
}

export default Product